import { useCallback, useEffect, useRef, useState } from "react";
import { training } from "services/api";
import { FlowAssignment } from "types";

export const useFlowAssignments = () => {
  const [data, setData] = useState<FlowAssignment[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchAssignments = useCallback(async () => {
    setLoading(true);
    try {
      const result = await training.flowAssignments();
      if (isMountedRef.current) {
        setData(result.flow_assignments ?? []);
        setError(null);
      }
    } catch (err) {
      console.error("Failed to load flow assignments:", err);
      if (isMountedRef.current) {
        setError("Failed to load module assignments");
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchAssignments().catch(() => null);
  }, [fetchAssignments]);

  return { data, loading, error, refetch: fetchAssignments };
};

export default useFlowAssignments;
